import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import NotificationBell from "../NotificationBell";
import EarningsLogo from "../Logo/earnings";
import BagLogo from "../Logo/bag";
import UserLogo from "../Logo/user";
import "./MobileQuickLinks.scss";

/**
 * Phones only (see MobileQuickLinks.scss): the tab bar keeps just Home, Cart,
 * (+) Assistant, Share and Social, so the rest of the desktop bar —
 * notifications, earnings, orders, account — sits here, above the footer.
 */
const MobileQuickLinks = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { email } = useSelector((state) => state.auth);
  if (!email) return null;

  const links = [
    { label: "Earnings", to: "/affiliate", Icon: EarningsLogo, active: /^\/(affiliate|earnings)/.test(pathname) },
    { label: "Orders", to: "/order", Icon: BagLogo, active: pathname.startsWith("/order") },
    { label: "Account", to: "/profile", Icon: UserLogo, active: pathname.startsWith("/profile") },
  ];

  return (
    <nav className="mobile-quick-links" aria-label="More">
      <NotificationBell className="mobile-quick-links__item" label="Notifications" />
      {links.map(({ label, to, Icon, active }) => (
        <button
          key={label}
          type="button"
          className={"mobile-quick-links__item" + (active ? " is-active" : "")}
          onClick={() => history.push(to)}
        >
          <Icon />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
};

export default MobileQuickLinks;
